// extracted by mini-css-extract-plugin
export default {"select":"SelectDropdown_select__WicvV"};